export const THEME_MODES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
} as const;

export const DARK_MODE_CLASS = 'dark';

export const THEME_MODE_STORAGE_KEY = 'theme-mode';
